module.exports = __webpack_public_path__ + "img/open-app.f18b0f27.png";